export { OtpErrors } from 'web-ui-kit/dist/uni-credit-otp-form/uni-credit-otp-form-constants';
export { ScratchErrors } from 'web-ui-kit/dist/uni-credit-scratch-card/uni-credit-scratch-card-constants';

export enum CommonErrors {
  SOMETHING_WENT_WRONG = 'something_went_wrong',
}

export enum SignInErrors {
  INVALID_USER = 'invalid_credentials',
}

export enum PhoneAuthErrors {
  INVALID_GRANT_CONSENT = 'invalid_grant_consent',
}

export enum PhoneConfirmErrors {
  ERROR_MOBILE_AUTH_CONSENT = 'error_mobile_auth_consent',
}

export enum CaptchaErrors {
  INVALID_CAPTCHA = 'invalid_captcha',
  BROKEN_CAPTCHA = 'something_went_wrong',
}

export enum BlockedErrors {
  BLOCKED_BY_BRUTEFORCE = 'bruteforce_block',
  BLOCKED_SCRATCH_CARD = 'scratch_card_code_many_attempts',
  BLOCKED_RECOVER_PASSWORD = 'error_second_question',

  BLOCKED_FULLY_BY_KYC = 'full_blocked_by_kyc',
  BLOCKED_FULLY_BY_KYC_VIP = 'full_blocked_by_kyc_vip',
  BLOCKED_FULLY_BY_DKO = 'full_dko_blocked',
  BLOCKED_MANUALLY = 'full_blocked',
}

export enum LoginErrors {
  LOGIN_ALREADY_EXISTS = 'username_already_exist',
}

export enum PasswordErrors {
  PASSWORD_INCORRECT = 'invalid_credentials',
}

export enum BankAccountErrors {
  BANK_ACCOUNT_INCORRECT = 'number_not_found',
}

export enum RegistrationErrors {
  USER_ALREADY_REGISTERED = 'user_already_registered',
}

export enum ResetPasswordErrors {
  REMOTE_RECOVERY_DISABLED = 'remote_access_disabled',
}

export enum SecureAnswerErrors {
  WRONG_ANSWER = 'error_first_question',
}

export enum CreatePasswordErrors {
  SAME_PASSWORD = 'invalid_password_format',
}
